'use client'

export function TestimonialSection() {
  return (
    <section
      className="bg-black py-16 md:py-32"
      style={{ fontFamily: 'var(--font-ppmori, PPMori), sans-serif' }}
    >
      <div className="mx-auto max-w-5xl space-y-8 px-6 md:space-y-16">
        <h2 className="relative z-10 max-w-xl text-4xl font-medium text-white lg:text-5xl">
          Real traders. Real results.
        </h2>

        <div className="relative">
          {/* Left: context */}
          <div className="relative z-10 space-y-4 md:w-1/2">
            <p className="text-white/60">
              Most traders start in Telegram groups and WhatsApp channels — paying monthly for signals that arrive late, lack context, and never explain the reasoning behind a trade.
            </p>
            <p className="text-white/60">
              Algoglide is built differently.{' '}
              <span className="font-medium text-white">
                Every signal comes with AI analysis, live chart context, and one-click execution
              </span>{' '}
              — all inside a single workspace connected directly to your exchange.
            </p>

            <div className="grid grid-cols-2 gap-3 pt-6 sm:gap-4">
              <div className="space-y-2">
                <h3 className="text-sm font-medium text-white">Signal groups</h3>
                <ul className="space-y-1 text-sm text-white/40">
                  <li>Delayed copy-paste alerts</li>
                  <li>No reasoning attached</li>
                  <li>Manual execution</li>
                  <li>$50 – $200/mo</li>
                </ul>
              </div>
              <div className="space-y-2">
                <h3 className="text-sm font-medium text-white">Algoglide</h3>
                <ul className="space-y-1 text-sm text-white/40">
                  <li>Live scanner, 400+ pairs</li>
                  <li>Algo reasoning on every alert</li>
                  <li>One-click execution</li>
                  <li>Full analytics suite</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Right: testimonial card */}
          <div className="md:mask-l-from-35% md:mask-l-to-55% mt-12 h-fit md:absolute md:-inset-y-12 md:inset-x-0 md:mt-0 md:flex md:items-center md:justify-end">
            <div className="relative border border-white/10 bg-white/[0.03] p-8 md:w-[52%]">
              {/* corner accents */}
              <span className="absolute top-0 left-0 h-4 w-4 border-t border-l border-white/25" />
              <span className="absolute top-0 right-0 h-4 w-4 border-t border-r border-white/25" />
              <span className="absolute bottom-0 left-0 h-4 w-4 border-b border-l border-white/25" />
              <span className="absolute bottom-0 right-0 h-4 w-4 border-b border-r border-white/25" />

              {/* quote mark */}
              <div
                className="mb-5 text-5xl leading-none text-white/15 select-none"
                aria-hidden
              >
                &ldquo;
              </div>

              <blockquote className="text-lg font-medium leading-relaxed text-white">
                I&apos;ve been in three paid Telegram groups and two WhatsApp signal channels — spent well over $300 a month between them. None of it comes close to what I get here. The scanner catches moves I&apos;d have missed, the reasoning actually makes sense, and I can execute in one click. This is what those groups wish they were.
              </blockquote>

              <div className="mt-6 flex items-center gap-3 border-t border-white/10 pt-5">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  src="/images/omar.png"
                  alt="Omar"
                  className="h-9 w-9 object-cover"
                />
                <div>
                  <div className="text-sm font-medium text-white">Omar</div>
                  <div className="text-xs text-white/40">Dubai</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
